import React from 'react';
import { IconButton } from 'material-ui';
import R from 'ramda';

const RowWidgets = ({ disabled, contract, templates, downloadContractPdf, goIntoContractOrWizard }) => {
  const { viewingBy, locationId, buyerChecked, files, _id, respondedContracts } = contract;
  const foundMatchedTemplate = R.find(R.allPass([
    R.eqProps('startDate', contract),
    R.eqProps('endDate', contract),
  ]), templates);
  const fileExists = files && files.length;
  const tcContractsInRequest = Boolean(!locationId && respondedContracts && respondedContracts.length);
  return (
    <IconButton
      disabled={disabled}
      data-cy={locationId || (buyerChecked && viewingBy === 'Contractor') ? `${_id}downloadRates` : `${_id}loadRates`}
      tooltip={(() => {
        if (locationId) return 'Download Rates';
        if (viewingBy === 'Supplier') {
          if (foundMatchedTemplate) return 'Send Rates';
          return 'Load Rates';
        }
        if (fileExists || tcContractsInRequest) return 'Download Rates';
        return 'Upload Files';
      })()}
      tooltipPosition="top-center"
      iconClassName={locationId || (fileExists && viewingBy === 'Contractor') || tcContractsInRequest ? 'tc-icon-get_app' : 'tc-icon-file_upload'}
      onTouchTap={(e) => {
        if (locationId || (fileExists && viewingBy === 'Contractor') || tcContractsInRequest) return downloadContractPdf(e.currentTarget);
        goIntoContractOrWizard();
      }}
    />
  );
};
RowWidgets.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default RowWidgets;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/list/downloadUploadButton.jsx